import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconFixedWidth16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconFixedWidth16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14 4a.5.5 0 0 0-1 0v8a.5.5 0 0 0 1 0zm-3 4a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5M2.5 3.5A.5.5 0 0 1 3 4v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconFixedWidth16);
